export default "__VITE_ASSET__D2cobNNm__"